<article class="rules-document">
  <header>
    <h1>Условия участия в торгах</h1>
    <p class="subtitle">(Публичная оферта)</p>
    <p class="last-updated">
      Последнее обновление: <time datetime="2025-12-12">12 декабря 2025 г.</time>
    </p>
  </header>

  <nav class="table-of-contents">
    <h2 class="toc-title">Содержание</h2>
    <ul class="toc-list">
      <li>
        <a role="button" (click)="scrollToSection($event, 'general-provisions')">Общие положения</a>
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'platform')">Платформа</a>
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'platform-usage')"
          >Использование Платформы через сотрудников и третьих лиц</a
        >
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'platform-access')">Доступ к Платформе</a>
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'deposit-refund')">Возврат депозита</a>
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'auction-types')">Типы аукционов</a>
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'auction-sheet')">Аукционный лист</a>
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'translation')"
          >Перевод аукционного листа</a
        >
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'corrections')"
          >Исправления аукционного листа</a
        >
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'preliminary-inspections')"
          >Предварительные осмотры</a
        >
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'compliance-check')"
          >Проверка соответствия</a
        >
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'bidding-rules')">Правила ставок</a>
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'lot-withdrawal')"
          >Снятие лота с торгов</a
        >
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'purchase-cancellation')"
          >Отмена ошибочной покупки</a
        >
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'seller-refusal')"
          >Отказ продавца от продажи</a
        >
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'relisting')"
          >Перевыставление автомобиля на аукцион</a
        >
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'additional-transport')"
          >Дополнительные транспортные расходы в Японии</a
        >
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'island-vehicles')"
          >Автомобили с островных территорий</a
        >
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'claims')">Претензия на аукцион</a>
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'content')">Контент</a>
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'terms-update')">Обновление условий</a>
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'communications')"
          >Коммуникации и споры</a
        >
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'applicable-law')"
          >Применимое право и юрисдикция</a
        >
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'language')"
          >Язык Условий и приоритет версий</a
        >
      </li>
      <li>
        <a role="button" (click)="scrollToSection($event, 'final-provisions')"
          >Заключительные положения</a
        >
      </li>
    </ul>
  </nav>

  <section id="general-provisions">
    <h2>Общие положения</h2>

    <p>
      Добро пожаловать на аукционную платформу www.jpauc.online ("Платформа"). Настоящие Условия
      участия в торгах ("Условия") регулируют порядок использования Платформы, а также все операции,
      связанные с покупкой транспортных средств через Платформу, управляемую оператором Платформы
      ("Оператор").
    </p>

    <p>
      Настоящие Условия являются публичной офертой. Перед началом использования Платформы Вы обязаны
      ознакомиться с настоящими Условиями и подтвердить свое согласие, отметив пункт "я согласен".
      Продолжая работать с Платформой, Вы подтверждаете, что ознакомились, поняли и безусловно
      согласны соблюдать настоящие Условия.
    </p>
  </section>

  <section id="platform">
    <h2>Платформа</h2>

    <p>
      Платформа предоставляет пользователям доступ к торгам, осуществляемым на реальных аукционных
      площадках Японии через уполномоченного Оператора. Оператор является официальным членом
      соответствующих аукционных домов и осуществляет участие в торгах от Вашего имени.
    </p>

    <p>
      Платформа получает информацию о транспортных средствах, выставленных на реальных японских
      аукционах. Данные передаются Платформе через интегрированные сервисы.
    </p>

    <p>
      Лоты публикуются в том виде, в котором они представлены аукционными домами. Платформа не
      изменяет описание, состояние или параметры лота. Соответственно, Платформа и Оператор не
      предоставляют каких либо гарантий относительно точности, полноты или достоверности информации
      о лотах и не несут ответственности за любые отклонения, ошибки, упущения, возникающие в
      результате использования данной информации.
    </p>

    <p>
      Вы выбираете лот и указываете максимальную сумму, которую готовы предложить. Ставка
      фиксируется в системе Платформы.
    </p>

    <p>
      Оператор торгуется на аукционе от Вашего имени, в соответствии с правилами площадки. Если
      ставка выигрывает, Вы получаете подтверждение посредством Платформы. Если ставка проигрывает,
      участие считается завершенным без обязательств по оплате.
    </p>
  </section>

  <section id="platform-usage">
    <h2>Использование Платформы через сотрудников и третьих лиц</h2>

    <p>
      Регистрация и использование Платформы осуществляется Вами как зарегистрированным контрагентом
      (юридическим лицом или индивидуальным предпринимателем), на которого оформляются все сделки,
      покупки и обязательства, возникающие в результате участия в торгах.
    </p>
    <p>
      Вы вправе через свой личный кабинет создавать, управлять и удалять дополнительные учетные
      записи (логины) для своих сотрудников, представителей и/или клиентов с целью подачи ставок и
      выполнения иных действий в рамках Платформы.
    </p>
    <p>
      Все действия, совершенные с использованием учетных записей, созданных Вами, включая, но не
      ограничиваясь: подачу, изменение и подтверждение ставок; участие в торгах, переговорах и
      лайв-торгах; подтверждение переводов, предварительных осмотров, исправлений аукционного листа;
      выражение согласия с условиями покупки, отмены или перевыставления, считаются совершенными
      Вами, независимо от того, кем фактически были выполнены такие действия — сотрудником,
      представителем, клиентом или иным третьим лицом.
    </p>
    <p>
      Вы несете полную и безусловную ответственность за все обязательства, финансовые последствия,
      штрафы, расходы и убытки, возникшие в результате действий любых лиц, получивших доступ к
      Платформе через созданные Вами учетные записи.
    </p>
    <p>
      Любые внутренние споры между Вами и Вашими сотрудниками, представителями или клиентами
      разрешаются Вами самостоятельно и не влияют на Ваши обязательства перед Платформой, Оператором
      и аукционными домами.
    </p>
  </section>

  <section id="platform-access">
    <h2>Доступ к Платформе</h2>

    <p>
      Доступ к Платформе предоставляется при условии наличия у Вас действующего депозита либо
      утвержденной кредитной линии.
    </p>
    <p>
      Для сохранения доступа к функциональности Платформы на Вашем балансе должен находиться
      достаточный депозит. Если депозит полностью израсходован либо его остаток становится
      недостаточным для дальнейшего участия в торгах, доступ к Платформе автоматически
      ограничивается до момента пополнения.
    </p>
    <p>
      Для Вас, использующих утвержденную кредитную линию, доступ к Платформе автоматически
      приостанавливается при достижении или превышении установленного лимита. Доступ возобновляется
      после погашения задолженности либо восстановления доступного кредитного лимита.
    </p>
    <p>
      Платформа оставляет за собой право автоматически ограничивать или приостанавливать доступ без
      предварительного уведомления при отсутствии достаточных денежных средств, превышении
      кредитного лимита либо иных нарушениях финансовых требований.
    </p>
  </section>

  <section id="deposit-refund">
    <h2>Возврат депозита</h2>

    <p>
      Возврат депозита возможен при отсутствии любой экспозиции по счету. Возврат осуществляется по
      Вашей письменной заявке исключительно на исходный банковский счет, с которого был произведен
      перевод, и на Ваше имя. Все банковские и валютные комиссии несете Вы. Запрос на возврат
      обрабатывается в течении 10 рабочих дней с момента письменного запроса.
    </p>

    <p>
      Оператор вправе зачесть депозит в счет аукционных сборов, штрафов, расходов на повторный
      аукцион, недостачи, логистики, инспекций или банковских комиссий. Депозит может также быть
      удержан в случае неисполнения платежных обязательств, отказа от покупки, мошенничества,
      фиктивных ставок, сговора или иных нарушений Условий.
    </p>
  </section>

  <section id="auction-types">
    <h2>Типы аукционов</h2>

    <p>
      Платформа предоставляет доступ к различным типам аукционных форматов, используемых аукционными
      домами Японии. Каждый формат имеет собственные правила проведения торгов, порядок подачи
      ставок и условия определения победителя.
    </p>

    <section class="subsection">
      <h3>Обычные аукционы</h3>

      <p>
        Обычные аукционы являются основным форматом торгов на японских аукционных площадках. Торги
        проходят в режиме реального времени, а ставки повышаются поэтапно. Оператор поднимает ставки
        от Вашего имени в пределах установленного Вами лимита. Победителем становится участник,
        предложивший наибольшую ставку на момент завершения торгов. Большинство автомобилей имеют
        скрытую резервную цену, установленную продавцом. До момента достижения резервной цены торги
        не гарантируют продажу автомобиля. Итоговая цена может оказаться ниже вашей максимальной
        ставки, но автомобиль останется непроданным, если резервная цена продавца выше предложенной
        суммы и в торгах остался один претендент.
      </p>
    </section>

    <section class="subsection">
      <h3>Тендерные аукционы</h3>

      <p>
        В тендерных аукционах все ставки являются скрытыми и не отображаются другим участникам. Вы
        устанавливаете максимальную ставку. Оператор передает ставку в тендерном формате без
        поэтапного повышения. Аукционный дом выбирает победителя на основе всех полученных
        предложений. Поскольку тендерная ставка передается как финальное ценовое предложение,
        покупка по цене ниже поданного Вами лимита невозможна. После подачи тендерная ставка не
        может быть изменена или отменена.
      </p>
    </section>

    <section class="subsection">
      <h3>Сателлитные аукционы</h3>

      <p>
        Сателлитные аукционы представляют собой удаленные торговые площадки функционирующие под
        управлением основного аукционного дома. Формат торгов аналогичен обычным аукционам. Условия
        продажи и правила подтверждения полностью соответствуют требованиям головной площадки. В
        связи с территориальным расположением сателлитных площадок, стоимость транспортировки
        автомобилей отличается от стоимости применяемой на головной площадке. Все логистические
        расходы подлежат оплате покупателем.
      </p>
    </section>

    <section class="subsection">
      <h3>Аукционы AUCNET и MOTA</h3>

      <p>
        AUCNET и MOTA являются виртуальными аукционными системами, не имеющих собственных стоянок
        или физических площадок. Лоты размещаются сторонними продавцами и дилерами, находящимися в
        различных регионах Японии. На этих виртуальных аукционных системах , есть отдельные разделы
        и категории лотов, для которых устанавливаются отличные от стандартных , повышенные
        аукционные сборы. Условия таких категорий, включая размер комиссий, сроки передачи
        автомобиля и документов, определяется сторонним поставщиком. Все дополнительные расходы и
        риски, связанные с участием в таких категориях лотов, включая повышенные аукционные сборы ,
        повышенные транспортные расходы и иные установленные платежи, несете Вы.
      </p>
    </section>

    <section class="subsection">
      <h3>Торги по блиц цене</h3>

      <p>
        Некоторые аукционные площадки предлагают формат One-Price, где автомобиль выставляется по
        фиксированной цене без проведения торгов. В этом формате участник, первым принявший
        установленную, цену, получает право на покупку лота. Для лотов One-Price аукционные дома
        применяют повышенный аукционный взнос, размер которого определяется соответствующей
        площадкой. Все дополнительные расходы, включая повышенный аукционный взнос, несете Вы.
      </p>
    </section>

    <section class="subsection">
      <h3>Покупка по переговорам</h3>

      <p>
        Если в ходе обычных торгов резервная цена продавца не была достигнута, аукционный дом может
        предложить формат покупки по переговорам. Переговоры доступны только после завершения
        торгов, в установленный аукционом промежуток времени и при условии, что резервная цена не
        была достигнута. Платформа и Оператор вступают в переговоры исключительно по Вашему запросу,
        направленному через Платформу. Оператор имеет право приобрести лот не выше размера Вашей
        исходной максимальной ставки, сделанной в ходе торгов, если не указано иное. При успешной
        покупке по переговорам аукционные дома, применяют повышенный аукционный взнос. Все
        дополнительные расходы, включая повышенный аукционный взнос, несете Вы. Платформа и
        Оператор: не гарантируют успешного исхода переговоров; не влияют на решение продавца; не
        контролируют временные рамки рассмотрения предложений; не несут ответственности за отказ
        продавца.
      </p>
    </section>

    <section class="subsection">
      <h3>Покупка по обратным переговорам</h3>

      <p>
        Покупка по обратным переговорам представляет собой формат приобретения транспортного
        средства, при котором продавец, после завершения аукционных торгов без достижения резервной
        цены, направляет встречное ценовое предложение. В рамках обратных переговоров: продавец
        указывает цену, по которой он готов продать автомобиль; предложение может быть направлено
        одному или нескольким участникам, ранее принимавшим участие в торгах; предложение действует
        в течение ограниченного срока, установленного аукционным домом.
      </p>

      <p>
        Оператор вправе самостоятельно принять решение о покупке автомобиля по обратным переговорам
        без дополнительного согласования с Вами, если предложенная продавцом цена равна либо ниже
        Вашей ранее зафиксированной максимальной ставки, указанной при участии в торгах.
      </p>

      <p>
        Покупка по обратным переговорам не является продолжением обычных торгов и не создает для Вас
        преимущественных прав, кроме предусмотренных правилами соответствующего аукционного дома.
      </p>
    </section>

    <section class="subsection">
      <h3>Лайв-торги с видеотрансляцией</h3>

      <p>
        Лайв-торги с видеотрансляцией представляют собой формат участия в аукционе, при котором
        Оператор осуществляет торги на аукционной площадке в режиме реального времени и
        предоставляет Вам видео-трансляцию хода торгов с возможностью повышения ранее поданной
        ставки.
      </p>

      <p>
        Данный формат является дополнительной платной услугой и предоставляется исключительно по
        предварительному согласованию. Лайв-торги с видеотрансляцией не являются стандартным
        способом участия в аукционах. Видеотрансляция носит исключительно вспомогательный и
        информационный характер и не заменяет функциональность Платформы.
      </p>
      <p>
        Вы признаете и соглашаетесь, что: видео трансляция может осуществляться с задержкой;
        возможны технические сбои, снижение качества изображения, прерывание трансляции или
        рассинхронизация с фактическим ходом торгов; Платформа и Оператор не гарантируют полное
        совпадение отображаемого в трансляции момента с реальным этапом аукциона.
      </p>
      <p>
        В случае если: видеотрансляция была прервана; подтверждение повышения ставки не было
        получено своевременно; время для повышения ставки было упущено, Оператор вправе продолжить
        участие в торгах, руководствуясь последней подтвержденной ставкой, либо прекратить
        дальнейшее повышение ставок для минимизации рисков.
      </p>
      <p>
        Все ставки и инструкции, подтвержденные Вами в рамках лайв-торгов с видеотрансляцией,
        являются юридически обязательными. Использование видеотрансляции не освобождает Вас от
        обязательств по оплате в случае выигрыша лота.
      </p>
      <p>
        Платформа и Оператор: не несут ответственности за проигрыш лота вследствие задержек,
        технических сбоев или ограничений видеотрансляции; не компенсируют убытки, возникшие в
        результате невозможности своевременно повысить ставку.
      </p>
    </section>
  </section>

  <section id="auction-sheet">
    <h2>Аукционный лист</h2>

    <p>
      Аукционный лист представляет собой документ аукционного дома, описывающий состояние автомобиля
      на момент проведения инспекции. Информация в аукционном листе предоставляется продавцом и
      инспектором аукционного дома и служит основным источником данных для принятия решения о
      покупке. Платформа публикует аукционные листы в том виде, в котором они получены от
      соответствующих аукционных систем без изменений. Платформа и Оператор : не подтверждают
      точность и полноту данных аукционного дома; не несут ответственность за скрытые дефекты, не
      указанные в аукционном листе.
    </p>

    <p>Аукционный лист, как правило, включает следующие сведения (их наличие не гарантируется):</p>
    <dl>
      <dt>Идентификационная информация:</dt>
      <dd>марка, модель, год, номер кузова / VIN.</dd>

      <dt>Технические характеристики:</dt>
      <dd>тип трансмиссии, привод, тип топлива, комплектация.</dd>

      <dt>Общее состояние:</dt>
      <dd>оценка внешнего и внутреннего состояния автомобиля.</dd>

      <dt>Конструктивные повреждения:</dt>
      <dd>
        сведения о наличии или отсутствии структурных ремонтов, восстановленных элементов или следов
        ДТП.
      </dd>

      <dt>Карта повреждений:</dt>
      <dd>обозначения вмятин, царапин, ржавчины, деформаций и других дефектов по кузову.</dd>

      <dt>Комментарии инспектора:</dt>
      <dd>
        информация о посторонних шумах, запахах, технических особенностях, модификациях, тюнинге и
        других наблюдениях.
      </dd>
    </dl>

    <p>
      Оценка автомобиля присваивается аукционным домом и отражает его общее техническое и визуальное
      состояние. Платформа и Оператор не предоставляют гарантий относительно субъективных оценок
      аукционного инспектора.
    </p>
  </section>

  <section id="translation">
    <h2>Перевод аукционного листа</h2>

    <p>Платформа предоставляет два вида переводов аукционных листов:</p>
    <ul>
      <li>Ручной перевод - выполняется сотрудниками Платформы по предварительному запросу.</li>
      <li>
        Автоматический ИИ перевод - предоставляется для всех лотов, доступных через интегрированные
        аукционные системы.
      </li>
    </ul>

    <section class="subsection">
      <h3>Ручной перевод</h3>

      <p>
        Ручные переводы выполняются по запросу и требуют дополнительного времени на обработку.
        Запрос должен быть отправлен не позднее чем за 3 часа до начала торгов лота на который,
        запрошен перевод. Запросы, поступившие позднее указанного срока, могут быть отклонены или
        выполнены без гарантии готовности к торгам. Перевод публикуется под Вашим лотом в Платформе.
      </p>

      <p>
        Если невозможно связаться с Вами всеми доступными способами, ставка не будет подана, чтобы
        избежать рисков покупки, без подтвержденного перевода.
      </p>

      <p>
        Платформа отвечает за корректность ручных переводов в пределах лингвистической интерпретации
        текста, представленного в аукционном листе.
      </p>

      <p>
        Ручной перевод выполняется специалистами - переводчиками, а не техническими экспертами.
        Поэтому ручной перевод: не является технической диагностикой; не подтверждает механическое
        состояние автомобиля; не интерпретирует глубину повреждений; не уточняет причины
        неисправностей; не определяет степень износа или необходимость ремонта. Переводчик передает
        только смысл текста инспектора, без технической оценки или толкования данных. Платформа не
        несет ответственности за любые решения, принятые исходя из технических предположений,
        сделанных на основе перевода.
      </p>

      <p>
        Вы несете ответственность за: изучение оригинального аукционного листа; проверку схем
        повреждений, условных обозначений, комментариев инспектора; интерпретацию технических кодов,
        индексов и символов; принятие решений на основании аукционного листа, а не перевода.
        Платформа не обязана разъяснять аукционные обозначения и не несет ответственность за их
        интерпретацию пользователем.
      </p>
    </section>

    <section class="subsection">
      <h3>Автоматический ИИ перевод</h3>

      <p>
        ИИ перевод предоставляется автоматически исключительно для ознакомления. Может содержать
        ошибки распознавания текста, формулировок и символов. Лоты без запросов на ручной перевод,
        не требуют от Вас подтверждения торгов и торгуются автоматический. Если Вы покупаете
        автомобиль без запроса ручного перевода, вся ответственность за понимание ИИ перевода лежит
        на Вас.
      </p>

      <p>
        Платформа не гарантирует и не несет ответственности за : точность и полноту автоматических
        ИИ переводов; различия между переводом и оригинальным листом; неверную интерпретацию
        автоматического ИИ перевода.
      </p>
    </section>
  </section>

  <section id="corrections">
    <h2>Исправления аукционного листа</h2>

    <p>
      Исправления аукционного листа представляют собой официальные корректировки, публикуемые
      аукционным домом после первоначального размещения лота и до либо во время проведения торгов.
      Исправления могут касаться любой информации, содержащейся в аукционном листе, включая, но не
      ограничиваясь: пробег; оценку; аварийную историю; комментарии инспектора.
    </p>

    <p>
      Исправления публикуются исключительно аукционным домом. Платформа и Оператор передают их в том
      виде, в котором они получены от аукционной системы. Вы получите уведомление.
    </p>
    <p>
      Уведомления являются вспомогательной функцией. Платформа не несет ответственности , если Вы не
      получили или не увидели уведомление вовремя. Вы обязаны самостоятельно отслеживать наличие и
      содержание исправлений аукционного листа до начала торгов через Платформу.
    </p>

    <p>
      Если исправление затрагивает существенные характеристики автомобиля (пробег, ДТП,
      конструктивные элементы, оценку), Платформа или Оператор вправе запросить у Вас дополнительное
      подтверждение намерения участвовать в торгах. В случае невозможности связаться с Вами всеми
      доступными способами ставка может быть отклонена во избежание рисков спорной покупки.
    </p>

    <p>
      Платформа и Оператор: не несут ответственности за содержание, своевременность и полноту
      исправлений, публикуемых аукционным домом; не гарантируют, что исправления будут опубликованы
      до момента подачи ставки; не несут ответственности за убытки, возникшие в результате поздней
      публикации исправлений аукционным домом.
    </p>

    <p>
      Исправления аукционного листа являются частью официальных аукционных данных. Наличие или
      отсутствие исправлений не создает дополнительных прав на отмену покупки, если иное прямо не
      предусмотрено правилами соответствующего аукционного дома.
    </p>
  </section>

  <section id="preliminary-inspections">
    <h2>Предварительные осмотры</h2>

    <p>
      Аукционные площадки (есть исключения) предоставляют платную услугу предпродажного осмотра
      автомобиля, которую они предоставляют в день торгов. Вы можете запросить организацию такого
      осмотра через Платформу не позднее чем за 3 часа до торгов соответствующего лота. Все расходы,
      связанные с предварительным осмотром, несете Вы. Стоимость, объем и содержание услуги
      определяются соответствующим аукционным домом или его подрядчиком.
    </p>

    <p>
      В случае, если после получения Оператором результатов осмотра невозможно связаться с Вами
      всеми доступными способами, ставка не будет одобрена, чтобы избежать рисков покупки, без
      подтвержденного результата осмотра.
    </p>

    <p>
      Подтверждая ставку, Вы : соглашаетесь принять автомобиль в состоянии на момент проведения
      торгов; подтверждаете, что ознакомились со всей доступной информацией; принимаете на себя
      риски, связанные с возможными скрытыми дефектами, неполнотой данных, возможными ошибками
      подрядчиков или аукциона; отказываетесь от претензий к Платформе и Оператору, основанных на
      расхождении между ожиданиями и фактическим состоянием автомобиля.
    </p>
  </section>

  <section id="compliance-check">
    <h2>Проверка соответствия</h2>

    <p>
      Вы несете полную ответственность за проверку соответствия приобретаемого автомобиля
      требованиям Вашей страны ввоза, включая , но не ограничиваясь:
    </p>
    <ul>
      <li>годом выпуска, допустимым к импорту;</li>
      <li>
        экологическими и техническими стандартами, включая нормы выбросов, конструктивные требования
        и сертификацию;
      </li>
      <li>
        регуляторными и правовыми ограничениями, применимыми к определенным типам транспортных
        средств;
      </li>
      <li>таможенными правилами, ограничениями и процедурами оформления;</li>
      <li>санкционными и разрешительными режимами, действующими в Вашей стране.</li>
    </ul>

    <p>
      Вы обязаны самостоятельно подтвердить возможность ввоза автомобиля до подачи ставки. Все
      риски, связанные с невозможностью ввоза, регистрации или эксплуатации автомобиля в Вашей
      стране, полностью лежат на Вас. Это также включает случаи, когда автомобиль не проходит
      требуемую инспекцию или сертификацию в Японии, предусмотренную правилами страны ввоза.
    </p>
  </section>

  <section id="bidding-rules">
    <h2>Правила ставок</h2>

    <section class="subsection">
      <h3>Срок подачи ставок</h3>

      <p>
        Ставки на обычные аукционы рекомендуется подавать не позднее чем за 1 час до начала торгов
        на этот лот. Ставки, поданные позже указанного срока, могут быть приняты Платформой, однако
        Платформа не гарантирует их обработку или успешную передачу на аукцион.
      </p>

      <p>
        Ставки на тендерные аукционы принимаются строго до 13:00 (по японскому времени) в день
        торгов. Запросы поданные после 13:00 , не принимаются и не обрабатываются, независимо от
        обстоятельств. Платформа не несет ответственности за невозможность подачи тендерной ставки
        при обращении после установленного времени.
      </p>

      <p>
        Аукционные дома могут изменять время начала торгов без предварительного уведомления. Такие
        изменения могут повлиять на возможность подачи, изменения или отмены ставки.
      </p>

      <p>
        Платформа не несет ответственности за любые последствия, вызванные : переносом времени
        торгов; ускорением начала торгов; техническими или организационными изменениями со стороны
        аукционного дома; невозможностью своевременно подать, изменить или отменить ставку
        вследствии таких изменений.
      </p>
    </section>

    <section class="subsection">
      <h3>Подача ставок</h3>

      <p>
        Все операции, связанные со ставками такие как : подача ставок, запросы на изменение или
        отмену ставок, подтверждение в торгах после перевода, подтверждение участия после
        предварительного осмотра, запрос на покупку по переговорам - должны выполняться только через
        интерфейс Платформы.
      </p>

      <p>
        Платформа не принимает и не обрабатывает ставки или подтверждения, отправленные: по
        телефону,через WhatsApp , через Viber, через Telegram, на почту, любым иным способом вне
        Платформы.
      </p>

      <p>
        Любые ставки или инструкции, переданные такими способами, не считаются действительными, не
        обрабатываются и не создают для Платформы никаких обязательств.
      </p>
    </section>

    <section class="subsection">
      <h3>Пережим ставки</h3>

      <p>
        Чтобы уменьшить риск проигрыша из-за минимального превосходства ставки другим участником,
        Платформа может применять защитный шаг пережима:
      </p>
      <ul>
        <li>Ставка до 300,000 йен - автоматический пережим до 25,000 йен;</li>
        <li>Ставка свыше 300,000 йен - автоматический пережим до 50,000 йен.</li>
      </ul>

      <p>
        Защитный пережим используется исключительно для повышения вероятности победы и не является
        гарантией покупки.
      </p>

      <p>
        Аукционные торги проходят в условиях высокой скорости обработки ставок и значительной
        волатильности. В связи с этим возможны незначительные отклонения между запрошенной Вами
        максимальной ставкой и фактической суммой покупки. Платформа не несет ответственности за
        минимальные превышения лимита, вызванные высокой динамикой торгов.
      </p>
    </section>

    <section class="subsection">
      <h3>Групповые ставки</h3>

      <p>
        Групповая ставка - это механизм, позволяющий Вам подать ставки на несколько лотов, когда Вас
        устраивает покупка любого из них. Платформа не ограничивает: количество лотов в одной
        группе, количество групп или количество целевых покупок в рамках одной или нескольких групп.
      </p>

      <p>
        Для минимизации риска одновременной покупки нескольких автомобилей Платформа рекомендует,
        чтобы разница во времени начала торгов между лотами одной группы составляла не менее 30
        минут. Платформа может принять группы с меньшим интервалом, однако Вы несете все риски,
        включая покупку нескольких автомобилей при совпадении времени.
      </p>

      <p>
        Платформа не гарантирует, что время начала торгов совпадает с опубликованным графиком, так
        как аукционные дома могут изменять время и скорость торгов.
      </p>

      <p>Тендерные аукционы не могут быть включены в групповые ставки.</p>
    </section>

    <section class="subsection">
      <h3>Внутренние конкурирующие ставки</h3>

      <p>
        Если несколько клиентов одновременно подают ставки на один и тот же автомобиль, Платформа
        применяет механизм приоритезации максимальной ставки. Это полностью соответствует принципам
        японских аукционных домов, где победителем всегда становится участник с наибольшим
        предложением.
      </p>

      <p>
        При наличии нескольких внутренних ставок на один лот приоритет получает тот клиент,
        указавший более высокий максимальный лимит. Ставка с более низким максимальным лимитом
        автоматически считается вторичной и не применяется, если не превышает ставку другого
        клиента.
      </p>

      <p>
        Если у автомобиля появились конкурирующие ставки внутри Платформы: Вы не видите конкретную
        сумму ставки другого клиента; Вы получаете уведомление, что для данного автомобиля
        существует ставка выше Вашего текущего максимального лимита.
      </p>

      <p>
        Для перебивания действует минимальный шаг в 30,000 йен. Количество перебиваний не
        ограничено.
      </p>

      <p>
        Повышение ставки рекомендуется делать не позднее чем за 1 час до начала торгов. Запросы на
        повышение, поданные позже, могут быть приняты или отклонены. Если ставка принята, она
        считается активной и подлежащей торгам.
      </p>

      <p>
        Вы получаете оповещение на телеграмм при каждом перебитии вашей ставки оппонентом. При
        получении оповещения, вы можете либо повысить ставку, либо не предпринимать действий, в
        результате чего ставка останется неизменной и в случае покупки лот будет отдан клиенту с
        максимальной ставкой, даже если Ваша ставка проходит в цене.
      </p>

      <p>
        Вы несете ответственность за: своевременное повышение ставок, контроль поступающих
        уведомлений, принятие решений о повышении или отказе от ставки, понимание того, что
        отсутствие ответа при уведомлении может привести к проигрышу торгов. Платформа не несет
        ответственности в случае, если вы своевременно не отреагировали на уведомление или перебили
        ставку менее чем за 1 час до торгов и Платформа не успела ее обработать.
      </p>

      <p>
        Уведомления являются вспомогательной функцией. Платформа не несет ответственности , если Вы
        не получили или не увидели уведомление вовремя.
      </p>

      <p>
        В случае возникновения внутренних конкурирующих ставок по одному и тому же лоту участие в
        торгах в формате лайв-трансляции не предоставляется и не применяется. Данное ограничение
        обусловлено необходимостью обеспечения равных условий для всех участников и соблюдения
        принципа приоритезации максимальной ставки.
      </p>
    </section>

    <section class="subsection">
      <h3>Отмена или изменение ставки</h3>

      <p>
        Отмена или изменение одобренной ставки в Платформе возможны только: если аукционный дом
        допускает отмену и если позволяет время до торгов. Платформа не гарантирует возможность
        отмены или изменения , даже при своевременном запросе.
      </p>
    </section>

    <section class="subsection">
      <h3>Ответственность</h3>

      <p>
        Ставки могут быть отклонены, не обработаны или пропущены в результате : задержек передачи
        данных, изменений расписаний торгов, технических работ со стороны аукционного дома, сетевых
        или системных сбоев и других факторов. Платформа и Оператор не несут ответственности в
        случае пропуска лота из-за факторов, находящихся вне ее контроля.
      </p>
    </section>

    <section class="subsection">
      <h3>Обязательность ставки</h3>

      <p>
        Любая ставка, введенная Вами через Платформу, считается действительной независимо от ошибок,
        опечаток или неверного ввода суммы. Каждая ставка, поданная через Платформу, является
        юридически обязывающим предложением на покупку автомобиля. Если Ваша ставка выигрывает, Вы
        автоматически принимаете обязательство оплатить и выкупить автомобиль на условиях
        аукционного дома.
      </p>
    </section>
  </section>

  <section id="lot-withdrawal">
    <h2>Снятие лота с торгов</h2>

    <p>
      Снятие лота с торгов означает отмену участия транспортного средства в аукционе по инициативе
      аукционного дома либо продавца до момента завершения торгов по соответствующему лоту. Снятие
      лота может быть произведено по различным причинам, включая, но не ограничиваясь: отзыв лота
      продавцом; выявление ошибок или несоответствий в аукционном листе; технические или
      организационные причины со стороны аукционного дома; изменения в решении продавца о продаже;
      иные обстоятельства, предусмотренные правилами аукционного дома.
    </p>

    <p>
      Решение о снятии лота принимается исключительно аукционным домом. Платформа и Оператор не
      влияют на данное решение и не гарантируют, что лот будет выставлен до момента завершения
      торгов.
    </p>
    <p>
      В случае снятия лота с торгов: все ранее поданные ставки по данному лоту аннулируются; покупка
      считается несостоявшейся; у Вас не возникает обязательств по оплате данного лота; экспозиция
      по счету, связанная с данным лотом, подлежит освобождению.
    </p>
    <p>
      Платформа и Оператор: не несут ответственности за причины снятия лота; не компенсируют
      упущенную выгоду или иные косвенные убытки, связанные со снятием лота; не гарантируют
      повторное выставление данного транспортного средства на будущих торгах.
    </p>
    <p>
      Если лот был снят после подачи Вами ставки, но до завершения торгов, данное обстоятельство не
      создает для Вас права на предъявление претензий к Платформе или Оператору.
    </p>
  </section>

  <section id="purchase-cancellation">
    <h2>Отмена ошибочной покупки</h2>

    <p>
      Отмена покупки после выигрыша торгов возможна не на всех аукционах и регулируется
      исключительно правилами соответствующего аукционного дома. Платформа не принимает решений об
      отмене и не влияет на стоимость штрафов или порядок их применения.
    </p>

    <section class="subsection">
      <h3>Общие условия отмены</h3>

      <p>
        Большинство японских аукционных домов допускают отмену покупки в ограниченный временной
        период от 30 до 120 минут с момента завершения торгов по лоту. Сроки и возможность отмены
        определяются аукционным домом, а не Платформой, и могут различаться в зависимости от
        площадки, типа лота и формата торгов. После истечения разрешенного времени отмена невозможна
        при любых обстоятельствах.
      </p>

      <p>
        Платформа не гарантирует возможность подачи запроса на отмену в установленные сроки,
        поскольку обработка зависит от времени реакции аукционного дома и административных процедур.
      </p>

      <p>
        Некоторые категории лотов могут быть недоступны для отмены, включая, но не ограничиваясь:
        лоты, которым аукционный дом присвоил обозначения, указывающие на серьезные повреждения или
        значительный ремонт; специальные категории, для которых аукционный дом прямо запрещает
        отмену; покупки, выполненные в формате "Переговоры", где отмена чаще всего невозможна.
      </p>

      <p>
        Правила отмены определяются исключительно аукционным домом и могут различаться в зависимости
        от площадки, категории лота и типа торгов.
      </p>
    </section>

    <section class="subsection">
      <h3>Штрафы за отмену</h3>

      <p>
        При отмене ошибочной покупки аукционный дом взимает совокупный штраф , который как правило,
        составляет ¥100,000 для стандартных лотов и ¥150,000 для дорогих автомобилей. Фактическая
        сумма может отличаться в зависимости от правил конкретного аукционного дома, типа торгов и
        времени подачи запроса..
      </p>

      <p>
        Штраф оплачивается полностью за счёт покупателя и должен быть внесен в установленный срок.
      </p>
      <p>Платформа не компенсирует штрафы и не участвует в их регулировании.</p>
    </section>
  </section>

  <section id="seller-refusal">
    <h2>Отказ продавца от продажи</h2>

    <p>
      В соответствии с правилами японских аукционных домов продавец сохраняет право отказаться от
      продажи автомобиля после завершения торгов в установленных аукционом случаях. Платформа не
      контролирует решения продавца и не несет ответственности за отмену сделки по инициативе
      продавца. Платформа передает решения аукционного дома в неизмененном виде и не участвует в
      переговорах между продавцом и аукционом.
    </p>

    <p>
      Если продавец отменяет продажу, Ваш депозит остается на Вашем аккаунте и может быть
      использован Вами для участия в следующих торгах. Возврат депозита осуществляется в
      соответствии с общими условиями Платформы.
    </p>

    <p>Платформа не компенсирует убытки, связанные с отменой продажи продавцом.</p>
  </section>

  <section id="relisting">
    <h2>Перевыставление автомобиля на аукцион</h2>

    <p>
      Перевыставление автомобиля на аукцион может быть применено в случаях, когда Вы, после победы в
      торгах, обращаетесь с запросом отменить покупку, но стандартная отмена недоступна или ее
      применение приводит к несоразмерным финансовым расходам.
    </p>

    <p>
      Перевыставление не является отменой покупки и не гарантирует освобождение от финансовых
      обязательств. Данный механизм используется исключительно как альтернативный способ минимизации
      возможных потерь.
    </p>
    <p>
      В случае перевыставления автомобиля: первоначальная покупка считается завершенной и не
      подлежит отмене; все расходы, связанные с перевыставлением, включая аукционные сборы, штрафы,
      административные расходы и иные платежи, несете Вы.
    </p>
    <p>
      В случае если по результатам повторной продажи цена автомобиля окажется ниже первоначальной
      цены покупки, Вы обязаны оплатить разницу между первоначальной ценой покупки и ценой повторной
      продажи, а также все сопутствующие расходы, установленные аукционным домом.
    </p>
    <p>
      Платформа и Оператор: не гарантируют успешную продажу автомобиля при перевыставлении; не
      гарантируют достижение определенной цены; не несут ответственности за финансовый результат
      перевыставления; не компенсируют убытки, возникшие в результате повторных торгов.
    </p>
  </section>

  <section id="additional-transport">
    <h2>Дополнительные транспортные расходы в Японии</h2>

    <p>
      Приобретенные через Платформу автомобили могут повлечь за собой дополнительные транспортные и
      сопутствующие расходы на территории Японии. Все такие расходы оплачиваете Вы.
    </p>
    <p>
      Дополнительные расходы могут возникать, включая, но не ограничиваясь, в следующих случаях:
    </p>
    <ul>
      <li>
        автомобили, находящиеся на стоянках, удалённых от основного аукционного двора или
        логистических хабов;
      </li>
      <li>автомобили с заниженной или завышенной подвеской;</li>
      <li>автомобили, не находящиеся в исправном ходовом состоянии (не на ходу);</li>
      <li>автомобили высотой более 2 метров;</li>
      <li>автомобили с установленными багажниками на крыше или иными выступающими элементами;</li>
      <li>
        автомобили с серьезными утечками масла, топлива, охлаждающей жидкости или иных технических
        жидкостей;
      </li>
      <li>
        автомобили, приобретенные через переговоры, продажу по фиксированной цене (One-Price) или
        через аукционные системы AUCNET , Mota и аналогичные;
      </li>
      <li>грузовые автомобили, автобусы, специальная и коммерческая техника;</li>
      <li>
        необходимость применения погрузочно-разгрузочной техники, эвакуаторов, лебедок или
        специальных средств перемещения.
      </li>
    </ul>
    <p>
      Все указанные и иные дополнительные расходы, связанные с перемещением, хранением, обработкой и
      подготовкой автомобиля к дальнейшей отгрузке, полностью несете Вы. Платформа и Оператор не
      обязаны заранее оценивать либо фиксировать размер таких расходов.
    </p>
  </section>

  <section id="island-vehicles">
    <h2>Автомобили с островных территорий</h2>

    <p>
      Автомобили, приобретенные на островных территориях Японии, подлежат предварительной доставке
      до материковой части Японии, как правило, в формате паромной перевозки, до момента дальнейшей
      логистической обработки.
    </p>

    <p>
      Несоответствие автомобиля требованиям паромной перевозки может повлечь применение
      альтернативных, более дорогих способов транспортировки за Ваш счет. Платформа и Оператор не
      несут ответственности за невозможность использования паромной перевозки и не компенсируют
      расходы, возникшие вследствие несоответствия автомобиля установленным требованиям.
    </p>

    <section class="subsection">
      <h3>Минимальные требования для паромной перевозки</h3>

      <p>
        Для возможности перевозки автомобиля на пароме транспортное средство должно соответствовать
        следующим минимальным требованиям:
      </p>
      <ul>
        <li>дорожный просвет не менее 15 см;</li>
        <li>капот должен нормально открываться;</li>
        <li>
          автомобиль должен быть на ходу: двигатель запускается, коробка передач функционирует,
          автомобиль способен самостоятельно двигаться;
        </li>
        <li>
          рулевое управление и шины: колёса поворачиваются, шины исправны, держат давление и
          позволяют передвижение;
        </li>
        <li>тормозная система: рабочий тормоз и стояночный тормоз исправный;</li>
        <li>
          автомобиль должен заезжать и выезжать самостоятельно, без использования буксировки,
          лебёдки, крана или иной вспомогательной техники;
        </li>
        <li>стёкла: лобовое стекло целое; боковые и задние стекла установлены и закрываются;</li>
        <li>
          внутреннее пространство: салон, багажник и багажники на крыше должны быть полностью
          пустыми, без личных вещей, запчастей или иного груза.
        </li>
      </ul>
    </section>

    <section class="subsection">
      <h3>Ограничения на перевозку паромом</h3>

      <p>
        Перевозка автомобиля паромом не допускается, если присутствует хотя бы одно из следующих
        обстоятельств:
      </p>
      <ul>
        <li>
          двигатель не запускается либо автомобиль не способен к самостоятельному передвижению;
        </li>
        <li>наличие белого или чёрного дыма из двигателя, выхлопной системы или других узлов;</li>
        <li>утечки масла, топлива, охлаждающей жидкости или иных технических жидкостей;</li>
        <li>поврежденные, дефектные или нестабильные гибридные или электрические батареи;</li>
        <li>
          отсутствие лобового стекла либо отсутствие, повреждение или ненадежная фиксация боковых
          или задних стекол;
        </li>
        <li>
          наличие в салоне, багажнике или кузове любых посторонних предметов или дополнительного
          груза.
        </li>
      </ul>
    </section>
  </section>

  <section id="claims">
    <h2>Претензия на аукцион</h2>

    <p>
      Претензии по приобретенным транспортным средствам могут быть заявлены исключительно в рамках
      правил соответствующего аукционного дома. Платформа и Оператор не принимают самостоятельных
      решений о допустимости, содержании или удовлетворении претензий и действуют исключительно как
      посредник при их передаче.
    </p>

    <p>
      Претензии допускаются только в случаях и в сроки, прямо предусмотренные правилами конкретной
      аукционной площадки. Несоблюдение установленных сроков или порядка подачи претензии
      автоматически лишает Вас права на ее рассмотрение.
    </p>

    <p>
      Подача претензии осуществляется исключительно по Вашей инициативе через Ваш личный кабинет
      после направления Вами соответствующей заявки. Платформа и Оператор не принимают
      самостоятельных решений о подаче претензий и не инициируют их без Вашего прямого запроса.
      Подача претензии возможна только при соблюдении всех требований и процедур, установленных
      соответствующим аукционным домом.
    </p>

    <section class="subsection">
      <h3>Срок подачи претензий</h3>

      <p>Типовые сроки подачи претензий (могут отличаться в зависимости от аукционного дома):</p>
      <ul>
        <li>несоответствие экстерьера или интерьера — в день проведения торгов;</li>
        <li>ошибки в регистрационных данных или спецификациях — до 7 календарных дней;</li>
        <li>аварийные или конструктивные повреждения — до 10 календарных дней;</li>
        <li>дефекты двигателя или трансмиссии — до 15 календарных дней.</li>
      </ul>

      <p>
        Окончательные сроки и порядок рассмотрения определяются исключительно правилами аукционного
        дома.
      </p>
    </section>

    <section class="subsection">
      <h3>Ограничения и исключения по претензиям</h3>

      <p>
        Претензии по приобретенным транспортным средствам рассматриваются исключительно в пределах и
        на условиях, установленных соответствующим аукционным домом. В случаях, указанных ниже,
        претензии не принимаются, ограничиваются либо могут быть отклонены без рассмотрения по
        существу, независимо от характера выявленных недостатков.
      </p>

      <section class="subsubsection">
        <h4>Категории лотов без права претензий</h4>

        <p>
          Претензии не принимаются по лотам, отнесенным аукционным домом к специальным категориям,
          предусматривающим продажу без права предъявления претензий, включая, но не ограничиваясь:
          лоты с обозначениями Accident, Low Price, White Corner и иными аналогичными категориями;
          специальные и уцененные категории, для которых правилами аукционного дома прямо установлен
          режим продажи «as-is».
        </p>
        <p>
          Квалификация лота как относящегося к таким категориям определяется исключительно
          аукционным домом и не подлежит пересмотру.
        </p>
      </section>

      <section class="subsubsection">
        <h4>Возраст и пробег автомобиля</h4>

        <p>
          Для автомобилей, достигших порога, при котором правила аукциона вводят ограничения по
          претензиям (часто встречающиеся пороги: 10 лет и/или 150,000 км, а также иные пороги
          конкретной площадки), претензии по крупным агрегатам и/или отмена сделки могут быть
          ограничены или сопровождаться особыми условиями компенсации/расходов.
        </p>
      </section>

      <section class="subsubsection">
        <h4>Дефекты, указанные в аукционной документации</h4>

        <p>
          Претензии не принимаются по любым дефектам, особенностям или несоответствиям, которые:
          указаны в аукционном листе; отражены в исправлениях аукционного листа ;прямо или косвенно
          обозначены в комментариях инспектора; являются очевидными при визуальном осмотре или
          логически вытекают из описания состояния автомобиля.
        </p>
      </section>

      <section class="subsubsection">
        <h4>Двигатель, трансмиссия, гибридные и электрические системы</h4>

        <p>
          Если в аукционном листе уже есть запись о симптомах / неисправностях двигателя / КПП /
          гибридной системы, то претензии по этим узлам часто исключаются либо рассматриваются
          только в исключительных случаях по усмотрению аукциона.
        </p>
      </section>

      <section class="subsubsection">
        <h4>Модификации, ремонты и вмешательства</h4>

        <p>
          Претензии не принимаются, если автомобиль: был модифицирован, тюнингован или до-оснащен
          нестандартными элементами; имеет признаки нештатного ремонта, восстановления или
          конструктивных изменений; относится к форматам продаж, предусматривающим специальные
          условия (переговоры, специальные продажи, отдельные категории аукциона).
        </p>
      </section>

      <section class="subsubsection">
        <h4>Экспорт и изменение статуса автомобиля</h4>

        <p>
          Претензии не принимаются, если: автомобиль был вывезен за пределы Японии; автомобиль
          прошел таможенное оформление или иные процедуры, после которых осмотр или проверка
          аукционным домом невозможны; автомобиль был передан третьим лицам либо с ним произведены
          действия, исключающие возможность объективной проверки.
        </p>
      </section>

      <section class="subsubsection">
        <h4>Повторная претензия по одному и тому же основанию</h4>

        <p>
          По одному и тому же лоту повторные обращения (2-я и последующие претензии) могут быть
          ограничены или не приниматься, кроме отдельных «критических» случаев (например, серьезные
          юридические/идентификационные нарушения), если это предусмотрено правилами площадки.
        </p>
      </section>

      <section class="subsubsection">
        <h4>Ограничения по форме компенсации и лимитам</h4>

        <p>
          Даже когда претензия в принципе допустима, аукционные правила могут: ограничивать верхний
          предел компенсации / снижения цены (особенно для недорогих лотов); устанавливать особые
          условия распределения расходов (например, по транспортировке и аукционным сборам) при
          отмене / возврате.
        </p>
      </section>

      <section class="subsubsection">
        <h4>Окончательная оговорка</h4>

        <p>
          Все транспортные средства приобретаются на условиях «как есть» (as-is), если иное прямо не
          предусмотрено правилами соответствующего аукционного дома.
        </p>
        <p>
          Платформа и Оператор: не расширяют перечень допустимых претензий; не изменяют правила их
          рассмотрения; не несут ответственности за отказ аукционного дома в принятии или
          удовлетворении претензии.
        </p>

        <p>
          Решение аукционного дома по претензии является окончательным и обязательным для сторон.
        </p>
      </section>
    </section>
  </section>

  <section id="content">
    <h2>Контент</h2>

    <p>
      Аукционные листы, фотографии, видеоматериалы и иные данные, получаемые от аукционных домов,
      предоставляются исключительно для целей участия в торгах.
    </p>
    <p>Вам запрещается:</p>
    <ul>
      <li>
        копировать, сохранять, публиковать или распространять аукционные листы, фотографии или их
        части;
      </li>
      <li>использовать такие материалы в маркетинговых, коммерческих или публичных целях;</li>
      <li>передавать данные третьим лицам вне рамок собственных внутренних решений о покупке.</li>
    </ul>
  </section>

  <section id="terms-update">
    <h2>Обновление условий</h2>

    <p>
      Оператор вправе в любое время в одностороннем порядке изменять, дополнять или обновлять
      настоящие Условия, включая любые разделы, приложения и ссылки, без предварительного
      согласования с Вами.
    </p>
    <p>Обновленная редакция Условий вступает в силу с момента её публикации на Платформе.</p>
    <p>
      Продолжение использования Платформы после публикации обновленной редакции Условий означает
      полное и безусловное принятие Вами всех изменений и дополнений, независимо от факта
      ознакомления с ними.
    </p>
    <p>
      В случае несогласия с обновленными Условиями Вы обязаны немедленно прекратить использование
      Платформы. Прекращение использования не освобождает Вас от исполнения обязательств, возникших
      до даты прекращения доступа, включая оплату, штрафы, расходы и иные обязательства.
    </p>
    <p>
      Оператор не обязан направлять индивидуальные уведомления о внесении изменений в Условия.
      Размещение обновленной редакции на Платформе является достаточным и надлежащим способом
      уведомления.
    </p>
  </section>

  <section id="communications">
    <h2>Коммуникации и споры</h2>

    <p>
      В случае возникновения любых вопросов, разногласий, претензий или споров, связанных с
      использованием Платформы, участием в торгах, результатами торгов, расчетами или иными
      аспектами взаимодействия, Вы обязаны в первую очередь обратиться к Оператору.
    </p>
    <p>
      Публикация Вами либо лицами, действующими от Вашего имени, негативных, дискредитирующих или
      вводящих в заблуждение заявлений, отзывов, комментариев или материалов о Платформе, Операторе,
      аукционных домах либо результатах торгов в публичных источниках (включая, но не ограничиваясь,
      социальные сети, мессенджеры, форумы, сайты-отзовики и СМИ) без предварительного обращения к
      Оператору рассматривается как нарушение настоящих Условий.
    </p>
    <p>
      В случае такой публикации Оператор вправе: считать соответствующую сделку завершенной и
      закрытой; прекратить предоставление консультационной, сервисной и иной поддержки по
      соответствующему лоту или сделке; приостановить либо ограничить дальнейшее обслуживание Вас в
      рамках Платформы.
    </p>
  </section>

  <section id="applicable-law">
    <h2>Применимое право и юрисдикция</h2>

    <p>
      Настоящие Условия, а также все отношения, возникающие в связи с использованием Платформы,
      участием в торгах, подачей ставок, покупкой транспортных средств и исполнением обязательств,
      регулируются исключительно законодательством Японии.
    </p>
    <p>
      Все споры, разногласия или требования, возникающие из настоящих Условий либо в связи с ними,
      подлежат разрешению исключительно в судах Японии.
    </p>
    <p>
      Исключительная территориальная подсудность определяется по месту нахождения Оператора, если
      иное прямо не предусмотрено императивными нормами законодательства Японии.
    </p>
  </section>

  <section id="language">
    <h2>Язык Условий и приоритет версий</h2>

    <p>Настоящие Условия составлены на английском языке.</p>
    <p>
      В случае если Платформа предоставляет перевод настоящих Условий на иные языки, такие переводы
      носят исключительно информационный характер.
    </p>
    <p>
      В случае расхождений, противоречий или различий в толковании между версиями Условий приоритет
      имеет версия, опубликованная на Платформе и признанная Оператором основной.
    </p>
  </section>

  <section id="final-provisions">
    <h2>Заключительные положения</h2>

    <p>
      Настоящие Условия представляют собой публичную оферту в понимании применимого
      законодательства.
    </p>
    <p>Акцептом настоящей оферты считается:</p>
    <ul>
      <li>регистрация на Платформе;</li>
      <li>подтверждение согласия с Условиями;</li>
      <li>подача любой ставки, подтверждения или иного действия через Платформу.</li>
    </ul>

    <p>
      С момента акцепта настоящие Условия приобретают юридическую силу договора между Вами и
      Оператором без необходимости подписания отдельного документа.
    </p>
  </section>
</article>
